<div class="assignment-map__main">
    <sl-split-layout direction="vertical">
        <ws-timeline slot="start" [dataSource]="timelineDataSource" (eventSelected)="onShiftSelected($any($event))"
            (drop)="onTimelineDrop($event)" (dateClick)="onDateClick($event)"></ws-timeline>
        <ws-work-plan-map slot="end" [assignments]="assignments" [value]="currentAssignment" [datasource]="mapDataSource"
            (valueChange)="onAssignmentSelect($event)" (editAssignment)="editing=true" (deleteAssignment)="onDeleteAssignment()"
            (lockAssignment)="onLockAssignment()" (unlockAssignment)="onUnlockAssignment()"
            [currentDate]="currentDate"></ws-work-plan-map>

    </sl-split-layout>

</div>

<div class="assignment-map__workplan-wrapper">
    <div class="assignment-map__workplan-menu">
        <sl-tooltip content="Create task" i18n-content><sl-icon-button (click)="onAddNewAssignment()" name="plus"></sl-icon-button></sl-tooltip>
        
        <sl-dropdown placement="bottom-end">
            <sl-icon-button slot="trigger" name="file-earmark-arrow-down"></sl-icon-button>
            <sl-menu (slSelect)="onMenuMoreSelect($any($event))">
                <sl-menu-item value="download-invoices" i18n>Download invoices</sl-menu-item>
                <sl-menu-item value="download-worksheets" i18n>Download worksheets</sl-menu-item>
            </sl-menu>
        </sl-dropdown>

        <sl-dropdown placement="bottom-end">
            <sl-icon-button slot="trigger" name="three-dots"></sl-icon-button>
            <sl-menu (slSelect)="onMenuMoreSelect($any($event))">
                <sl-menu-item value="complete" i18n>Mark completed</sl-menu-item>
                <sl-menu-item value="notify" i18n>Send notifications</sl-menu-item>
                <sl-menu-item value="move" i18n>Move assignments</sl-menu-item>
                <sl-menu-item value="postpone" i18n>Postpone plan</sl-menu-item>
                <sl-menu-divider></sl-menu-divider>
                <sl-menu-item value="affix" i18n>Fix service windows</sl-menu-item>
                <sl-menu-item value="detach" i18n>Remove service windows</sl-menu-item>
                <sl-menu-divider></sl-menu-divider>
                <sl-menu-item value="lock" i18n>Lock to dato</sl-menu-item>
                <sl-menu-item value="unlock" i18n>Unlock from date</sl-menu-item>
                <sl-menu-divider></sl-menu-divider>
                <sl-menu-item value="select" i18n>Select assignments</sl-menu-item>
            </sl-menu>
        </sl-dropdown>
    </div>
    <ws-workplan class="assignment-map__workplan" [assignments]="assignments" [contacts]="contacts" [groups]="groups" [selectable]="selectableWorkplan" (selectionChange)="onWorkplanSelectionChange($event)"
        [value]="currentAssignment" (valueChange)="onAssignmentSelect($event)" (keydown)="onWorkplanKeyDown($event)"></ws-workplan>
    <ws-shift-summary 
        [totalStops]="totalStops"
        [totalAmount]="totalAmount" 
        [totalAmountCompleted]="totalAmountCompleted"
        [totalDuration]="totalDuration" 
        [totalDistance]="totalDistance" 
        [distanceOut]="distanceOut" 
        [distanceBetween]="distanceBetween" 
        [distanceHome]="distanceHome"
        [currency]="currency">
    </ws-shift-summary>
</div>

<sl-drawer [open]="editing" placement="bottom" style="--size: 90vh;" no-header>
    <ws-assignment-editor-view *ngIf="editing" (click)="$event.stopPropagation()" [cancelable]="true" (canceled)="onEditCanceled()" (saved)="onEditSaved()" [id]="currentAssignment?.id" [date]="currentDate" [accountId]="currentResourceId"></ws-assignment-editor-view>
</sl-drawer>

